<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">{{title}}</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'market-info'" :fileName="'combinedrank'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
          <filtersMrkt
            ref="mrkFilt"
            @filter="filtData"
            @filterDate="filtDate"
            :filterOptions="filterOptions"
          ></filtersMrkt>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selRangeFilter" @change="filterRangeData($event)">
              <option
                v-for="(d, index) in mcOptions"
                v-bind:key="d.id+index"
                :value="index"
              >{{d.value}}</option>
            </select>
          </div>
          <!-- <mcfilter :rawData="rawData" :searchData="searchData" @updateRawData="updaterdata"> </mcfilter> -->
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table class="table table-bordered fonts11 app-inner">
          <thead>
            <tr>
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="title+'field'+index+key"
              >
                {{field.name}}
                <i
                  class="fa fa-caret-down"
                  v-if="(field.sort_order == 1 || field.sort_order == 0)"
                ></i>
                <i
                  class="fa fa-caret-up"
                  v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rawData" v-bind:key="title+'row'+index">
              <td v-for="(field, ind) in tableFields" v-bind:key="title+'td'+ind">
                <span v-if="field.isLink">
                  <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                </span>
                <span
                  v-else
                >{{(field.isNumeric && (field.title).search("rank") === -1)? getFixed(row[field.title]): row[field.title]}}</span>
                <!-- {{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}} -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-danger" role="alert"  v-if="rawData.length==0">No data found!</div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  // mixins: [commonMixins, mrktCommonMixins],
  props: ["title", "mcOptions", "combinedData"],
  created() {
    // this.getRawData();
    if (this.rawData.length > 0) {
      this.searchData = rawData;
      console.log(new Date(this.rawData[0].date));
      this.ddate = new Date(this.rawData[0].date);
    }
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      tableFields: [],
      rawData: [],
      rawDataList: [],
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: "",
      maxRange: "",
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      selFilter: "",
      selRangeFilter: 0
    };
  },
  methods: {
    //Filter Data on Market cap range
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          console.log(
            rd.marketCapitalization_latest,
            this.selRangeFilter,
            minRange,
            maxRange
          );
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange) &&
              parseInt(rd["marketCapitalization_latest"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange)
              );
            }
            if (maxRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) <=
                parseInt(maxRange)
              );
            }
          }
        });
      }
      setTimeout(() => {
        this.sortColumn(this.tableFields[2], 2);
      });
    },
    filtData(obj) {
      console.log("Filter", obj, JSON.stringify(obj));
      // this.ddate = new Date(obj.durDate);
      this.minRange = obj.min;
      this.maxRange = obj.max;
      this.selFilter = obj.selField;
      this.filterData();
    },
    clearData() {
      // this.selRangeFilter = 0;
      // this.selFilter = "";
      this.searchText = "";
      this.rawData = this.searchData;
    },
    getTableFields() {
      if (this.rawData.length > 0) {
        var tblFields = Object.keys(this.rawData[0]);
        this.tableFields = [];
        tblFields.forEach((val, key) => {
          if (val !== "co_code" && val !== "date") {
            this.tableFields.push({
              title: val,
              name: this.getCustomLabel(val),
              isNumeric: val === "companyname" ? false : true,
              sort_order:
                val === "rank"
                  ? 1
                  : val === "companyname"
                  ? 2
                  : val === "marketCapitalization_latest"
                  ? 3
                  : 5,
              isLink: val === "companyname" ? 1 : 0,
              isSortable: 1
            });
          }
          if (
            val !== "co_code" &&
            val !== "date" &&
            val !== "companyname" &&
            val !== "rank"
          ) {
            this.filterOptions.push({
              id: val,
              value: this.getCustomLabel(val),
              isNumeric: true,
              sort_order: (val==='marketCapitalization_latest')? 1: 2
            });
          }
        });
        this.tableFields = this.sorted_fields_asc(
          this.tableFields,
          "sort_order"
        );
        console.log("Table fields", this.tableFields);
      }
    }
  },
  computed: {},
  watch: {
    combinedData: function(value) {
      this.rawData = value;
      this.getTableFields();
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/combinedRankData.vue